import React from 'react'

import classes from './ButtonsFooter.module.scss'

export function ButtonsFooter({ children }) {
  return <footer className={classes.buttonsFooter}>{children}</footer>
}
